<template>
  <div class="modal-card">
    <div class="modal-card-body">
      <h6><span class="has-text-black-bis has-text-weight-bold">{{terminalBeingBuilt.value.name}}</span></h6>
      <table class="table is-fullwidth is-narrow">
        <thead>
          <tr>
            <td></td>
            <td>Unit Price</td>
            <td>Quantity</td>
            <td>Total</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span v-if="wholesale">MSRP</span>
              <span v-else>Retail</span>
            </td>
            <td>{{ terminalBeingBuilt.value.msrpPrice ? $numeral(terminalBeingBuilt.value.msrpPrice).format('$0,0') : 'N/A'}}</td>
            <td>{{builtTerminal.quantity}}</td>
            <td>{{ terminalBeingBuilt.value.msrpPrice ? $numeral(terminalBeingBuilt.value.msrpPrice * builtTerminal.quantity).format('$0,0') : 'N/A'}}</td>
          </tr>
          <tr v-if="wholesale">
            <td>Wholesale</td>
            <td>{{terminalBeingBuilt.value.wholesalePrice ? $numeral(terminalBeingBuilt.value.wholesalePrice).format('$0,0') : 'N/A'}}</td>
            <td>{{builtTerminal.quantity}}</td>
            <td>{{terminalBeingBuilt.value.wholesalePrice ? $numeral(terminalBeingBuilt.value.wholesalePrice * builtTerminal.quantity).format('$0,0') : 'N/A'}}</td>
          </tr>
        </tbody>
      </table>
      <hr>
      <h6><span class="has-text-black-bis has-text-weight-bold">{{warranty.priceObject.name}}</span></h6>
      <p>First year is included in terminal purchase.</p>
      <table class="table is-fullwidth is-narrow" v-if="warranty.quantity > 0">
        <thead>
          <tr>
            <td></td>
            <td>Unit Price</td>
            <td>Extra Years</td>
            <td>Terminals</td>
            <td>Total</td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <span v-if="wholesale">MSRP</span>
              <span v-else>Retail</span>
            </td>
            <td>{{$numeral(warranty.priceObject.msrpPrice).format('$0,0')}}</td>
            <td>{{warranty.quantity}}</td>
            <td>{{builtTerminal.quantity}}</td>
            <td>{{$numeral(warranty.priceObject.msrpPrice * warranty.quantity * builtTerminal.quantity).format('$0,0')}}</td>
          </tr>
          <tr v-if="wholesale">
            <td>Wholesale</td>
            <td>{{$numeral(warranty.priceObject.wholesalePrice).format('$0,0')}}</td>
            <td>{{warranty.quantity}}</td>
            <td>{{builtTerminal.quantity}}</td>
            <td>{{$numeral(warranty.priceObject.wholesalePrice * warranty.quantity * builtTerminal.quantity).format('$0,0')}}</td>
          </tr>
        </tbody>
      </table>
      <hr v-if="chosenAccessories.value.length">
      <div v-if="chosenAccessories.value.length">
        <div v-for="accessory in chosenAccessories.value" :key="accessory.id" class="mt-4">
          <h6><span class="has-text-black-bis has-text-weight-bold">{{accessory.name}}</span></h6>
          <table class="table is-fullwidth is-narrow">
            <thead>
              <tr>
                <td></td>
                <td>Unit Price</td>
                <td>Quantity</td>
                <td>Total</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span v-if="wholesale">MSRP</span>
                  <span v-else>Retail</span>
                </td>
                <td>{{accessory.msrpPrice ? $numeral(accessory.msrpPrice).format('$0,0') : 'N/A'}}</td>
                <td>{{accessory.quantity}}</td>
                <td>{{accessory.msrpPrice ? $numeral(accessory.msrpPrice * accessory.quantity).format('$0,0') : 'N/A'}}</td>
              </tr>
              <tr v-if="wholesale">
                <td>Wholesale</td>
                <td>{{accessory.wholesalePrice ? $numeral(accessory.wholesalePrice).format('$0,0') : 'N/A'}}</td>
                <td>{{accessory.quantity}}</td>
                <td>{{accessory.wholesalePrice ? $numeral(accessory.wholesalePrice * accessory.quantity).format('$0,0') : 'N/A'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['terminalBeingBuilt', 'builtTerminal', 'chosenAccessories', 'warranty', 'wholesale']
}
</script>
